import React, { useState, useContext, useRef, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import { useTranslation } from "react-i18next";
import { TextField, InputAdornment } from "@mui/material";
import infoIcon from "../../images/infoIcon.svg";
import "../../styles/components/Editor.scss";
import "../../styles/pages/Banners/BannerManager.scss";
import "../../styles/components/EditorModal.scss";
import ErrComponentToRender from "../../Uitls/apiErrorHandling";
import DropDownWithLabelTemplate from "../DropDownWithLabelTemplate.js";
import DropDownWithLabelSizeTemplate from "../../components/DropdownWithLabelSizeTemplate.js";
import {
  getNewBrandsAndcampaigns,
  basedOnBanner,
  getMarketList,
} from "../../services/apis";
import DropDownWithSearchTemplate from "../DropDownWithSearchTemplate";
import { templateSizes } from "../../Uitls/RightPanelToolBarItems";
import TextFieldInputTemp from "../../components/CommonComponents/TextFieldInputTemp";
import { toast } from "react-toastify";
import { nameValidation } from "../../Uitls/Util.js";
import ValueContext from "../../ContextAPi/appContext";
import Button from "@mui/material/Button";

export default function BasedOnModalNew(props) {
  const history = useHistory();
  const { t } = useTranslation();
  const { recentlyViewedData } = props;
  const appData = useContext(ValueContext);
  const [brandsAndCampaigns, setBrandsAndCampaigns] = useState([]);
  const [marketDataSource, setMarketDataSource] = useState([]);
  const [selectedMarket, setSelectedMarket] = useState(undefined);
  const [helperText, setHelperText] = useState("");
  const [errorMsg, setErrorMsg] = useState(false);
  const templateSizeOptions = ["Pre-defined", "Custom"];
  const [attributes, setAttributes] = useState({});
  const [genericInfo, setGenericInfo] = useState({
    brand: "",
    campaign: "",
    market: "",
    bannerNameInput: "",
    templateSizeType: "",
    templateSize: "",
    promomatTempDocId: "ES-BVY-0064",
    templateType: "",
  });
  const dropdownWidth = useRef(null);

  const handleFormReset = () => {
    setGenericInfo({
      brand: "",
      campaign: "",
      market: "",
      bannerNameInput: "",
      templateNameInput: "",
    });
    setSelectedMarket("");
  };

  React.useEffect(() => {
    setGenericInfo({
      ...genericInfo,
      campaign: "",
    });
  }, [appData?.genericInfo.brand]);

  React.useEffect(() => {
    fetchBrandsAndCampaigns();
    fetchMarketData();
    getCampaignListToPopulate(
      appData?.genericInfo?.brand || recentlyViewedData?.brand
    );

    appData?.genericInfo?.brand &&
      appData?.genericInfo?.brand !== "— Not Brand Specific —" &&
      setGenericInfo({
        ...genericInfo,
        campaign: appData?.genericInfo?.campaign,
        brand: appData.genericInfo.brand,
      });
  }, []);
  React.useEffect(() => {
    setGenericInfo({
      ...genericInfo,
      campaign: appData?.genericInfo?.campaign,
      brand: appData.genericInfo.brand,
      market: appData.genericInfo.market,
      templateType: appData?.genericInfo?.isAnimated ? "Animated" : "Static",
      templateSizeType: appData?.attributes?.customTemp
        ? "Custom"
        : "Pre-defined",
      templateSize: getTemplateSize(
        appData?.genericInfo?.height,
        appData?.genericInfo?.width
      ),
      Width: appData?.genericInfo?.width,
      Height: appData?.genericInfo?.height,
    });
    setAttributes(appData?.attributes);
  }, []);
  //Fetch Brands and campaigns
  const fetchBrandsAndCampaigns = () => {
    getNewBrandsAndcampaigns((response, err, errCode) => {
      if (err) {
        const errCoponent = ErrComponentToRender(errCode);
        toast.error(errCoponent);
      } else {
        //parse and save
        const data = response.data;
        if (data && data.length > 0) {
          let sortedData;
          sortedData = data.slice().sort((a, b) => {
            const brandNameA = a.brandName.trim().toUpperCase();
            const brandNameB = b.brandName.trim().toUpperCase();
            return brandNameA.localeCompare(brandNameB, "en", {
              sensitivity: "base",
            });
          });
          sortedData = [...sortedData].map((data) => {
            let object = data;
            object["displayName"] = `${object.brandName}`;
            return object;
          });
          setBrandsAndCampaigns(sortedData);
        }
      }
    });
  };

  //Returns Campaign list to populate in Drop down
  const getCampaignListToPopulate = (Brand) => {
    if (
      Brand &&
      brandsAndCampaigns.length > 0 &&
      Brand !== "— Not Brand Specific —"
    ) {
      const campaigns = brandsAndCampaigns.filter((object) => {
        return object.brandName === Brand;
      })[0]?.campaigns;
      if (campaigns && campaigns.length > 0) {
        const desiredList = campaigns.map((campaign) => {
          return campaign["campaignName"];
        });
        if (desiredList && desiredList.length > 0) {
          return desiredList;
        }
      }
    }
    return [];
  };

  function validateForm() {
    return (
      genericInfo.bannerNameInput?.length > 2 &&
      genericInfo?.brand !== "— Not Brand Specific —" &&
      genericInfo?.brand?.length > 0
    );
  }
  const handleChangeInfoDataBlur = (e) => {
    if (e.target.value.length < 3 && e.target.value.length !== 0) {
      toast.error(
        <div className="notificationText">
          {t("bannerManager.bnrNameMinErr")}
        </div>
      );
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    setGenericInfo({ ...genericInfo, [name]: value });
    if (name === "templateNameInput") {
      if (e.target.value.length > 255) {
        toast.error(
          <div className="notificationText">
            {t("bannerManager.tempNameErr")}
          </div>
        );
      }
    }

    if (brandsAndCampaigns) {
      brandsAndCampaigns.forEach((brand) => {
        if (brand.brandName === value) {
          appData.setBrandId(brand.brandId);
        }
        brand.campaigns.forEach((campaign) => {
          if (campaign.campaignName === value) {
            appData.setCampaignId(campaign.campaignId);
          }
        });
      });
    }
  };
  const handleChangeInfoData = (e) => {
    const { name, value } = e.target;
    setGenericInfo({ ...genericInfo, [name]: value });
    if (name === "bannerNameInput") {
      if (e.target.value.length > 500) {
        toast.error(
          <div className="notificationText">
            {t("bannerManager.bnrNameErr")}
          </div>
        );
      }
    }
    if (brandsAndCampaigns) {
      brandsAndCampaigns.forEach((brand) => {
        if (brand.brandName === value) {
          appData.setBrandId(brand.brandId);
        }
        brand.campaigns.forEach((campaign) => {
          if (campaign.campaignName === value) {
            appData.setCampaignId(campaign.campaignId);
          }
        });
      });
    }
    let obj = { ...appData?.genericInfo, [name]: value };
    appData.updateGenericInfo(obj);
    setErrorMsg(false);
    setHelperText("");
  };

  const fetchMarketData = () => {
    getMarketList((response, err, errCode) => {
      if (err) {
        const errCoponent = ErrComponentToRender(errCode);
        toast.error(errCoponent);
      } else {
        //parse and save

        const data = response.data;
        if (data) {
          let marketData = data;
          if (marketData && marketData.length > 0) {
            marketData = [...marketData].map((market) => {
              let object = {
                code: market.countryDamId,
                shortName: market.ShortName,
                name: market.marketName,
              };
              object["displayName"] = `${object.name}`;
              return object;
            });
            if (marketData && marketData.length > 0) {
              marketData = [...marketData].sort((marketOne, marketTwo) => {
                if (marketOne.name < marketTwo.name) {
                  return -1;
                }
                if (marketOne.name > marketTwo.name) {
                  return 1;
                }
                return 0;
              });
              setMarketDataSource(marketData);
            }
          }
        }
      }
    });
  };
  const handleMarketChange = (market) => {
    if (market) {
      setSelectedMarket(market);
      appData.setMarketCode(market.code);
      setGenericInfo({ ...genericInfo, market: market.name });
      appData.updateGenericInfo({
        ...appData?.genericInfo,
        market: market.name,
      });
    }
  };

  const getSelectedMarket = () => {
    if (!selectedMarket && appData && appData?.genericInfo?.market) {
      const countryName = appData?.genericInfo?.market;
      const countryCode = appData.marketCode;
      const displayName = `${countryName}`;
      return { name: countryName, code: countryCode, displayName: displayName };
    }
    return selectedMarket;
  };

  const cloneBannerData = () => {
    if (!nameValidation(genericInfo.bannerNameInput, "Banner")) return;

    var formData = new FormData();
    const match = genericInfo.templateSize.match(/\d{2,4}x\d{2,4}/);
    var templateSizeRes = match[0].split("x");
    formData.append("brandName", genericInfo?.brand ? genericInfo?.brand : "");
    formData.append("name", genericInfo?.bannerNameInput);
    formData.append("campaign", genericInfo?.campaign);
    formData.append("brandId", appData?.brandId);
    formData.append(
      "width",
      parseInt(templateSizeRes[0]) || parseInt(genericInfo.Width)
    );
    formData.append(
      "height",
      parseInt(templateSizeRes[1]) || parseInt(genericInfo.Height)
    );
    formData.append("marketName", appData?.genericInfo?.market);
    formData.append("marketCode", appData?.marketCode);
    formData.append("attributes", JSON.stringify(attributes));
    basedOnBanner(
      appData.assetInfo.assetId,
      formData,
      (response, err, errorCode, errorMessage) => {
        if (err) {
          const errCoponent = ErrComponentToRender(errorCode);
          if (err.response.data?.errorCode === "ERR_CS_ASSETNAME_EXISTS") {
            toast.error(
              <div className="notificationText">
                {t("apiErrors.errBannerExist")}
              </div>
            );
          } else {
            toast.error(
              <div className="notificationText">{t("apiErrors.err500")}</div>
            );
          }
        } else {
          const obj = {
            brand: response.data.brandName,
            campaign: response.data.campaign,
            market: response.data.marketName,
            templateNameInput: response.data.assetName,
          };
          appData.updateGenericInfo({ ...appData?.genericInfo, ...obj });
          setSelectedMarket(obj.market);
          appData.setAssetInfo({
            assetId: "",
            assetName: obj.templateNameInput,
          });

          localStorage.removeItem("assetId");
          localStorage.setItem("assetId", response.data.id);
          history.push(`/banner-editor/${response?.data?.id}`);
        }
      }
    );
  };

  const handleBrandChange = (e) => {
    const { name, value } = e.target;

    if (name === "templateNameInput") {
      if (e.target.value.length > 250) {
        toast.error(
          <div className="notificationText">
            {t("bannerManager.tempNameErr")}
          </div>,
          { autoClose: 1200, hideProgressBar: false }
        );
      }
    }
    setGenericInfo({ ...genericInfo, [name]: value });
    if (brandsAndCampaigns) {
      brandsAndCampaigns.forEach((brand) => {
        if (brand.brandName === value) {
          appData.setBrandId(brand.brandDamId);
        }
        brand.campaigns &&
          brand.campaigns.forEach((campaign) => {
            if (campaign.campaignName === value) {
              appData.setCampaignId(campaign.campaignId);
            }
          });
      });
    }
  };
  const handleChangeSizes = (e, id) => {
    let name = e.target.name;
    let value = e.target.value;
    setGenericInfo({
      ...genericInfo,
      templateSizeType: value,
      templateSize: "",
      Width: 0,
      Height: 0,
    });
  };
  function getTemplateSize(height, width) {
    for (let i = 0; i < templateSizes.length; i++) {
      const [name, size] = templateSizes[i].split(" ");
      const [templateWidth, templateHeight] = size.split("x").map(Number);

      if (templateWidth === width && templateHeight === height) {
        return templateSizes[i];
      }
    }

    return `${height}x${width}`;
  }

  useEffect(() => {
    setAttributes({
      ...attributes,
      customTemp: genericInfo?.templateSizeType === "Custom" ? true : false,
    });
  }, [genericInfo.templateSizeType]);
  return (
    <>
      <Dialog
        open={props.showBasedOn}
        onClose={() => props.setShowBasedOn(false)}
        className="newTemplateModal"
        aria-labelledby="form-dialog-title"
        overlaystyle={{ backgroundColor: "transparent" }}>
        <div className="row newBnrModal">
          <div
            className="baseOnModalHeading col-md-5 createbannerhead"
            style={{ fontFamily: "'Nunito Sans', sans-serif" }}
          >
            <p>{t("METADATA INFORMATION")}</p>
            <div className="details">
              <p className="sourcetag">Source</p>
              <p className="tagDescription">PromoMats</p>
              <hr className="custom-hr" />
            </div>
            <div className="details createdBtagy">
              <p className="sourcetag">Created by</p>
              <p className="tagDescription">-</p>
            </div>
            <div className="details">
              <p className="sourcetag">Created on</p>
              <p className="tagDescription">-</p>
            </div>
          </div>

          <div className="col-md-7 selectBrands customScrollBar">
            <TextField
              variant="standard"
              label={t("Banner Name")}
              name="bannerNameInput"
              className="bannerNameTextfield templateNameTextfield templateNameTextfieldChanges bnrtxtField"
              style={{ marginBottom: "8px " }}
              fullWidth={true}
              value={genericInfo.bannerNameInput}
              onChange={handleChangeInfoData}
              onBlur={handleChangeInfoDataBlur}
              autoComplete="off"
              InputProps={{
                endAdornment: (
                  <InputAdornment
                    position="end"
                    style={{ color: "gray", fontSize: "12px" }}
                  >
                    {genericInfo.bannerNameInput?.length > 0 &&
                      `${genericInfo?.bannerNameInput?.length}/500 chars`}
                  </InputAdornment>
                ),
              }}
              helperText={helperText}
              error={errorMsg}
            ></TextField>
            <TextField
              variant="standard"
              label={
                <>
                  {t("PromoMats Template Doc ID")}{" "}
                  <span style={{ color: "red" }}>*</span>
                </>
              }
              value={genericInfo?.promomatTempDocId}
              name="promomatTempDocid"
              className="bannerNameTextfield templateNameTextfield templateNameTextfieldChanges disablPromo iconinfo"
              fullWidth={true}
              autoComplete="off"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <img src={infoIcon} className="" />
                  </InputAdornment>
                ),
              }}
              disabled={true}
            ></TextField>

            {appData?.genericInfo?.brand === "— Not Brand Specific —" ? (
              <div className="newInputFieldTemp brandNm" ref={dropdownWidth}>
                <DropDownWithLabelTemplate
                  options={{
                    value:
                      genericInfo?.brand === "— Not Brand Specific —"
                        ? ""
                        : genericInfo?.brand,
                    name: "brand",
                    label: t("bannerManager.brandName"),
                    items: props.getBrandsToPopulate("basedOnNew"),
                    handleChange: handleBrandChange,
                  }}
                  menuWidth={
                    dropdownWidth.current?.getBoundingClientRect().width *
                      0.95 || undefined
                  }
                />
              </div>
            ) : (
              <TextField
                variant="standard"
                value={appData?.genericInfo?.brand}
                name="brand"
                label={"Product"}
                className="bannerNameTextfield  templateNameTextfield ChangleCloneTextField"
                fullWidth={true}
                onChange={handleChangeInfoData}
                autoComplete="off"
                disabled="true"
              ></TextField>
            )}
            <DropDownWithSearchTemplate
              options={{
                value: getSelectedMarket(),
                name: "market",
                label: "Country",
                items: marketDataSource,
                handleChange: handleMarketChange,
              }}
              className="custonScrollBar"
            />

            <TextField
              id="standard-basic"
              variant="standard"
              label={t("Banner Type")}
              name="templateType"
              className="bannerNameTextfield templateNameTextfield ChangleCloneTextField"
              fullWidth={true}
              value={genericInfo?.templateType}
              // onChange={handleChange}
              //onBlur={(e) => handleChangeInfoDataBlur(e)}
              autoComplete="off"
              disabled="true"
            />
            <div
              className="newInputFieldTemp newInputFieldTempChanges"
              style={{ marginTop: "0px" }}
              // style={{ marginRight: "0", marginTop: "6.5px" }}
            >
              <DropDownWithLabelTemplate
                options={{
                  value: genericInfo?.templateSizeType || "",
                  name: "templateSizeType",
                  // label: t("bannerManager.templateSize"),
                  label: (
                    <>
                      {t("Banner Size")} <span style={{ color: "red" }}>*</span>
                    </>
                  ),

                  items: templateSizeOptions,
                  handleChange: handleChangeSizes,
                  className: "testBannersize",
                }}
              />
            </div>

            {genericInfo?.templateSizeType === "Pre-defined" && (
              <div
                className={
                  genericInfo.templateSizeType === "Pre-defined"
                    ? "newSizeInputFieldTemp chooseSize newInputFieldTemp newSizeInputFieldTempWidth"
                    : "newSizeInputFieldTemp chooseSize2 newInputFieldTemp newSizeInputFieldTempWidth"
                }
              >
                <DropDownWithLabelSizeTemplate
                  //style={{ marginTop: "30px !important" }}
                  options={{
                    value: genericInfo.templateSize || "",
                    name: "templateSize",
                    // label: t("Choose Size"),
                    // t("bannerManager.templateSize")
                    label: (
                      <>
                        {t("Choose Size")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </>
                    ),
                    items: templateSizes,
                    handleChange: handleChange,
                    className: "testBannersize",
                  }}
                />
              </div>
            )}
            {genericInfo?.templateSizeType === "Custom" && (
              <TextFieldInputTemp
                assetType={"banner"}
                custom={true}
                setCustomSize={true}
                genericInfo={genericInfo}
                setGenericInfo={setGenericInfo}
                // bannerSizes={bannerSizes}
                handleChange={handleChange}
                styleClass="hWTemplate2"
              />
            )}
          </div>
        </div>
        <DialogActions className="modalActions templateBtn">
          <Button
            onClick={() => {
              props.setShowBasedOn(false);
              handleFormReset();
            }}
            color="primary"
            className="cancelBtntemp"
          >
            {t("bannerManager.cancel")}
          </Button>
          <Button
            onClick={cloneBannerData}
            type="submit"
            className="temp-btn"
            disabled={!validateForm()}
            autoFocus
            style={{ position: "relative", left: "-11px" }}
          >
            {t("create banner")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
